

























import TableRow from '@/components/TableRow.vue'
import OrderRouteTableCells from '@/components/new-design/OrderRouteTableCells.vue'
import NextLoadViewDetailsCell from './NextLoadViewDetailsCell.vue'

export default {
  components: {
    TableRow,
    OrderRouteTableCells,
    NextLoadViewDetailsCell
  },
  props: {
    order: { type: Object, required: true },
    multiStop: { type: Object, required: true },
    suggestedBaseCost: { type: Number, default: 0 }
  }
}
